import React from 'react';

import { LinkWithPulse } from '../../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';

const links = [
  {
    className: 'redirect-soMe instagram',
    id: 'redirect-to-instagram-vink',
    name: 'instagram',
    href: 'https://www.instagram.com/vinkoslo/',
  },
  {
    className: 'redirect-soMe tiktok',
    id: 'redirect-to-tiktok-vink',
    name: 'tiktok',
    href: 'https://www.tiktok.com/@vinkoslo',
  },
  {
    className: 'redirect-soMe facebook',
    id: 'redirect-to-facebook-vink',
    name: 'facebook',
    href: 'https://wwww.facebook.com/vinkoslo',
  },
];

const SoMe: React.FC = () => {
  return (
    <figure className="soMe-wrapper">
      <p className="soMe-wrapper__title">Følg Vink på sosiale medier</p>
      <div className="soMe-wrapper__body">
        {links.map((link) => (
          <div className="soMe-wrapper__circle" key={link.id}>
            <LinkWithPulse
              className={link.className}
              href={link.href}
              id={link.id}
              name={link.name}
            />
          </div>
        ))}
      </div>
    </figure>
  );
};

export default SoMe;
